import React from 'react';
import { useWeb3 } from '../context/Web3Context';

export default function ConnectWallet() {
  const { connect, connecting } = useWeb3();

  return (
    <div className="connect-wrap fade-in">
      <img
        className="connect-logo"
        src="/logo.png"
        alt="Evitta"
        onError={(e) => {
          e.currentTarget.style.display = 'none';
        }}
      />
      <h1 className="gold-text">EVITTA</h1>
      <p>The next-generation decentralized network platform. Connect your wallet to enter.</p>

      <button className="btn" onClick={connect} disabled={connecting}>
        {connecting ? <span className="spin-inline" /> : null}
        {connecting ? 'Connecting…' : 'Connect Wallet'}
      </button>

      <p className="dim" style={{ fontSize: 12 }}>
        Best experienced inside the Trust Wallet or MetaMask in-app browser.
      </p>
    </div>
  );
}
